export default {
  de: {
    name: 'Seiten Name',
    pagetypes: 'Seitenkategorie',
    pages: 'Seitenvorlage',
  },
};
